import {orderBy} from 'lodash'
import update from 'immutability-helper'
import React, {useContext} from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

import Dialog from 'components/responsive-fullscreen-dialog'
import PreviewQuestion from 'components/quiz/components/preview-question'

import {TeacherContext} from 'teacher/context'

import create from 'helpers/command'

export default function Settings (props) {

  const {question, classes} = props
  const context = useContext(TeacherContext)
  const {translate, updateState} = context
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [deleteOpened, openDeleteQuestionBank] = React.useState(false)
  const [moveToDirectoryOpened, openMoveToDirectory] = React.useState(false)
  const [directory, setDirectory]  = React.useState(question.directory || "")

  const openRowSettingsMenu = (e) => {
    setAnchorEl(e.currentTarget)
  }

  const closeRowSettingsMenu = (e, reason) => {
    setDirectory(question.directory || "")
    setAnchorEl(null)
  }

  function handleOpenDelete() {
    closeRowSettingsMenu()
    openDeleteQuestionBank(true)
  }

  async function handleDelete(confirmed) {
    openDeleteQuestionBank(false)
    if (!confirmed) return
    await create('quiz', 'deleteBankQuestion')({id: question.id})
    updateState({quizSearchQuestionBankCalls: {$apply: n => n + 1}})
  }

  async function handleShare () {
    closeRowSettingsMenu()
    const shared = !question.shared
    const [sharedId] = await create('quiz', 'shareBankQuestion')({id: question.id, shared})
    if (sharedId == question.id) {
      const index = context.quizQuestionBank.findIndex(({id}) => id == sharedId)
      if (index >= 0) {
        updateState({quizQuestionBank: {[index]: {shared: {$set: shared}}}})
      }
    }
  }

  return (
    <Box className={classes.moreSettings}>
      <Box className={classes.moreSettingsButton} onClick={openRowSettingsMenu}>
        <MoreVertIcon />
      </Box>
        <Menu
          id="settings-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={closeRowSettingsMenu}
        >
          <MenuItem onClick={handleShare}>{context.translate(question.shared ? 'unshare' : 'share')}</MenuItem>
          <MenuItem onClick={handleOpenDelete}>{context.translate('delete')}</MenuItem>
        </Menu>
      <Dialog
        open={deleteOpened}
        close={handleDelete}
        confirm={<Button variant="contained" color="primary" onClick={() => handleDelete(true)}>{translate('delete')}</Button>}
        cancel={<Button variant="contained" color="secondary" onClick={() => handleDelete()}>{translate('cancel')}</Button>}
        title={translate('confirm_delete_item')}
      >
        <PreviewQuestion headless showPoints context={context} question={question} />
      </Dialog>
    </Box>
  )
}
